<template>
  <HeaderPopup
    v-bind:onCloseClick="onCloseClick"
    v-bind:toggleButtonRef="toggleButtonRef"
  >
    <div class="lang-block">
      <HeaderPopupTitle class="lang-title">Select Language</HeaderPopupTitle>
      <div class="lang-block__list">
        <HeaderPopupListItem
          v-bind:key="l.value"
          v-for="l in languages"
          v-if="isPresentation ? presentationLanguages.includes(l.value) : true"
          v-bind:class="{
            'lang-select-content': true,
            'lang-select-content--active': l.value === lang,
          }"
          v-bind:onClick="() => selectLanguage(l.value)"
        >
          <div class="img-container">
            <img
              :src="getLanguageFlagName(l.value)"
              :alt="getLanguageName(l.value)"
            />
          </div>
          <div class="label">
            {{ l.name || l.value }}
          </div>
        </HeaderPopupListItem>
      </div>
    </div>
  </HeaderPopup>
</template>

<script>
import { mapState } from "vuex";
import HeaderPopup from "./header/HeaderPopup";
import HeaderPopupListItem from "./HeaderPopupListItem";
import HeaderPopupTitle from "./HeaderPopupTitle";
import { getLanguageFlagName, getLanguageName, languages, presentationLanguages } from "../helpers/getLanguageFlagName";

export default {
  components: {
    HeaderPopupTitle,
    HeaderPopupListItem,
    HeaderPopup,
  },
  props: {
    onCloseClick: Function,
    toggleButtonRef: HTMLElement,
  },
  name: "LanguageSelect",
  created() {
    this.languages = languages;
    this.presentationLanguages = presentationLanguages;
    this.getLanguageFlagName = getLanguageFlagName;
    this.getLanguageName = getLanguageName;
  },
  computed: {
    ...mapState("auth", ["lang"]),
    ...mapState("app", ["isPresentation"]),
  },
  methods: {
    selectLanguage(lang) {
      this.$store.dispatch("auth/selectLanguage", { lang });
    },
  },
};
</script>

<style scoped>
.lang-block {
  width: 240px;
  box-sizing: border-box;
}
.lang-title {
  margin: 0 16px 12px;
}
.lang-block__list {
  overflow-y: auto;
  max-height: 320px;
}
.lang-block__list::after {
  left: 0;
  width: calc(100% - 12px);
  bottom: 0;
  height: 50px;
  content: "";
  z-index: 2;
  position: absolute;
  background: linear-gradient(
    to top,
    rgb(255, 255, 255),
    rgba(255, 255, 255, 0)
  );
  pointer-events: none;
}

.lang-select-content {
  display: flex;
  justify-content: flex-start;
  padding: 0 16px;
  margin-bottom: 8px;
  width: inherit;
}

.lang-select-content--active .img-container {
  border: 2px solid #0821ff;
}

.img-container {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  border: 2px solid transparent;
  box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.05);
}
.img-container img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

@media (max-width: 600px) {
  .lang-block {
    width: 100%;
  }
}
</style>
